import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import useLocalStorageState from 'use-local-storage-state';
import { Accordion, Table } from 'react-bootstrap';
import { GetRequest, PostRequest } from '../../../../Utils/hooks/ApiHandler';
import { baseURL } from '../../../../Utils/constants/constant';
import FacebookModal from './FacebookModal';
import { toast } from 'sonner';
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png";

const FacebookLead = () => {
  const location = useLocation();
  const data = location?.search || null;

  const [customer, setCustomer] = useLocalStorageState("customer", { token: {} })
  const navigate = useNavigate()
  const customer_id = customer?.customer_details?.customer_id
  const token = customer?.token?.authorization || ""
  const rf = customer?.token?.authentication || ""
  const extras = { customer, setCustomer, rf, navigate }
  const headers = { Authorization: token, Authentication: rf }

  const [pages, setPages] = useState([]);

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const [editedData, setEditedData] = useState([])

  useEffect(() => {
    if (!data || data === null) return
    (async () => {
      const payload = {
        code: data.split("?code=")[1],
        customer_id: customer_id,
        user_login_id: customer?.customer_details?.id
      }
      try {
        const res = await PostRequest(`facebook/getFBData`, payload, false, { headers }, extras)
        if (res.success === false) return
        if (res.status === 'fail') {
          toast.error(res.message)
          return
        }
        toast.success(res.message)
        return
      } catch (error) {
        return
      }
    })()
  }, [data])

  const fetchPages = async () => {
    try {
      const res = await GetRequest(
        `${baseURL}facebook/fetchPages/${customer_id}`,
        { headers },
        extras
      );
      if (res?.status === "success") {
        const data = res.data || [];
        setPages(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchPages()
  }, [])

  const handleAddForm = async (page, form) => {
    if (!page || !form) return
    try {
      setSelectedPage(page);
      setSelectedForm(form);
      setModalOpen(true);
      const res = await GetRequest(
        `${baseURL}facebook/fetchFormData/${form?.form_id}/${form?.id}/${page?.page_id}`,
        { headers },
        extras
      )
      if (res.status === "success") {
        setEditedData(res?.data)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedPage(null);
    setSelectedForm(null);
    setEditedData([])
  };

  const isSynced = (formData) => {
    const { pipeline_id, pipeline_stage_id, marked_label } = formData
    if (!pipeline_id && !pipeline_stage_id && !marked_label) {
      return "No"
    }
    return "Yes"
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0" style={{ color: "#0791ff" }}>Facebook Lead Forms</h5>
        </div>

        <div className="card-body">
          <Accordion
            defaultActiveKey={pages?.[0]?.page_id?.toString()}
            className="sales-order-accordion shadow-none border-0 focus-ring-0 w-100"
          >
            {pages?.map((page) => (
              <Accordion.Item
                eventKey={page.page_id?.toString()}
                key={page.page_id}
              >
                <Accordion.Header className="shadow-none border-0 focus-ring-0 bg-transparent">
                  <span>
                    {page.page_name}
                    <span className="badge bg-primary ms-2">
                      {page.forms?.length || 0}
                    </span>
                  </span>
                </Accordion.Header>

                <Accordion.Body className="p-0">
                  <div className="table-responsive">
                    <Table className="accordion-table ">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Form Name</th>
                          <th>Form ID</th>
                          <th>Is Synced</th>
                          <th style={{ width: '80px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {page.forms?.length > 0 ? (
                          page.forms.map((form, idx) => (
                            <tr key={form.form_id}>
                              <td>{idx + 1}</td>
                              <td>{form.form_name}</td>
                              <td>{form.form_id}</td>
                              <td>
                                <span
                                  style={{ fontWeight: "500" }}
                                  className={`ms-1 ${isSynced(form) === "No" ? "text-danger" : "text-success"}`}
                                >
                                  {isSynced(form)}
                                </span>
                              </td>
                              <td className="text-center">
                                <button
                                  className="btn btn-default btn-sm"
                                  onClick={() => handleAddForm(page, form)}
                                >
                                  + Add
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center">No Forms Found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          {pages.length === 0 && (
           
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={nodata}
                  alt=""
                  style={{ width: "17rem", marginTop: "0" }}
                />
              </div>
         
          )}
        </div>
      </div>

      {/* Modal */}
      <FacebookModal
        show={modalOpen}
        onClose={handleModalClose}
        page={selectedPage}
        form={selectedForm}
        setEditedData={setEditedData}
        editedData={editedData}
        fetchPages={fetchPages}
      />


    </div>
  );
};

export default FacebookLead;